var _path, _path2, _line, _line2, _line3, _line4, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayoutSel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ruler",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.002,
    height: 23.002,
    viewBox: "0 0 23.002 23.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8809",
    "data-name": "Path 8809",
    d: "M0,0H23V23H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8810",
    "data-name": "Path 8810",
    d: "M4.958,4H18.376a.958.958,0,0,1,.958.958V9.75a.958.958,0,0,1-.958.958H11.667a.958.958,0,0,0-.958.958v6.709a.958.958,0,0,1-.958.958H4.958A.958.958,0,0,1,4,18.376V4.958A.958.958,0,0,1,4.958,4",
    transform: "translate(-0.166 -0.166)",
    fill: "none",
    stroke: "#0054a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_291",
    "data-name": "Line 291",
    x2: 2,
    transform: "translate(4 8)",
    fill: "none",
    stroke: "#0054a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_292",
    "data-name": "Line 292",
    x2: 3,
    transform: "translate(4 12)",
    fill: "none",
    stroke: "#0054a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_293",
    "data-name": "Line 293",
    x2: 2,
    transform: "translate(4 15)",
    fill: "none",
    stroke: "#0054a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_294",
    "data-name": "Line 294",
    y2: 2,
    transform: "translate(8 4)",
    fill: "none",
    stroke: "#0054a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8811",
    "data-name": "Path 8811",
    d: "M12,4V6.875",
    transform: "translate(-0.499 -0.166)",
    fill: "none",
    stroke: "#0054a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8812",
    "data-name": "Path 8812",
    d: "M16,4V5.917",
    transform: "translate(-0.665 -0.166)",
    fill: "none",
    stroke: "#0054a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutSel);
export default __webpack_public_path__ + "static/media/layout_sel.965a0935.svg";
export { ForwardRef as ReactComponent };